/* global $ */
const $userrating = $('[data-userrating]');

/**
 * Toggle rating radio buttons
 */
function toggleRatingButtons() {
  const $radiobuttons = $('[data-userrating-input]');

  $radiobuttons.on('change', (event) => {
    $radiobuttons.next('.icon').addClass('is-inactive');
    $(event.delegateTarget)
      .next('.icon')
      .removeClass('is-inactive');
    $(event.delegateTarget)
      .parent()
      .prevAll('[data-userrating-label]')
      .find('.icon')
      .removeClass('is-inactive');
  });
}

/**
 * Toggle filter checkboxes
 */
function toggleFilterCheckboxes() {
  const $filterGroup = $userrating.find('[data-filter-group]');
  const $filter = $filterGroup.find('[data-filter-item]');
  const $filterAll = $filterGroup.find('[data-filter-all]');

  $filter.on('change', () => {
    $filterAll.prop('checked', false);
  });

  $filterAll.on('change', () => {
    if ($filterAll.is(':checked')) {
      $filter.prop('checked', true);
    } else {
      $filter.prop('checked', false);
    }
  });
}

function addCharacterCounter() {
    const $textBox = $('[data-rating-text]');
    const $counterBox = $textBox.parent().find('[data-text-counter]');
    if ($counterBox.length > 0) {
      $textBox.restrictLength($counterBox);
    }
}

/**
 * Bind events
 */
function bindEvents() {
  if ($userrating.length) {
    toggleRatingButtons();
    toggleFilterCheckboxes();
    addCharacterCounter();
  }
}

/**
 * Exports
 */
export { bindEvents };
